module.exports = __webpack_public_path__ + "img/vegetable-potatoes-190x100.d2dc8493.jpg";